import axios from '@/request/axios'
import { agent, report } from '@/request/api'

const state = {
  list: [],
  detail: {},
  options: []
}

const getters = {
  agentA (state) {
    if (state['options'] != null && state['options'].length > 0) {
      return state['options'].filter(i => i.agentLevel === 'A')
    } else {
      return []
    }
  },
  agentB (state) {
    if (state['options'] != null && state['options'].length > 0) {
      return state['options'].filter(i => i.agentLevel === 'B')
    } else {
      return []
    }
  },
  normalA (state) {
    if (state['options'] != null && state['options'].length > 0) {
      return state['options'].filter(i => i.agentLevel === 'A' && Number(i.status) === 0)
    } else {
      return []
    }
  }
}

const mutations = {
  SET_DETAIL (state, val) {
    state.detail = val
  },
  SET_OPTIONS (state, val) {
    state.options = val
  }
}

const actions = {
  //  代理列表
  list ({}, data) {
    return axios.postFromDataRequest(agent.tableList, data)
  },
  //  代理详情
  detail ({}, data) {
    return axios.postFromDataRequest(agent.detail, data)
  },
  account ({}, data) {
    return axios.postFromDataRequest(agent.account, data)
  },
  //  新增代理
  add ({}, data) {
    return axios.postFromDataRequest(agent.add, data)
  },
  //  更新代理
  update ({}, data) {
    return axios.postFromDataRequest(agent.update, data)
  },
  //  检查代理状态
  check ({}, data) {
    return axios.postFromDataRequest(agent.check, data)
  },
  //  代理选项
  AgentList ({ commit }, data) {
    return new Promise((resolve, reject) => {
      axios.postFromDataRequest(agent.selectList, data)
        .then(res => {
          commit('SET_OPTIONS', res.data)
          resolve(res)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  //  代理报表列表
  agentReport ({ commit }, data) {
    return axios.postFromDataRequest(report.agent, data)
  },
  //  代理商户选项
  merchantList ({}, data) {
    return axios.postFromDataRequest(agent.merchantList, data)
  },
  //  代理商户选项
  allAgentList ({}, data) {
    return axios.postFromDataRequest(agent.allAgentList, data)
  },
  //  校验银行卡
  checkCard ({}, data) {
    return axios.getRequest(agent.checkCard, data)
  },
  //  读取营业执照信息
  licenseInfo ({}, data) {
    return axios.postFromDataRequest(agent.getBusinessLicense, data)
  },
  //  读取证件信息
  IdCardInfo ({}, data) {
    return axios.postFromDataRequest(agent.getIDCard, data)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/agent.js